import React, { useEffect, useState } from 'react';
import { Alert, Col, Container, Row, Spinner } from 'react-bootstrap';
import { XAxis, YAxis, CartesianGrid, Tooltip, Line, LineChart, ResponsiveContainer, PieChart, Pie } from 'recharts';
import { connect } from 'react-redux';
import { apiUrl, businessName } from '../../utils/consts';
import { formatMoney } from '../../utils/formatMoney';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import highchartsMap from 'highcharts/modules/map';
import proj4 from 'proj4';
import mapDataIE from '@highcharts/map-collection/countries/co/co-all.geo.json';

highchartsMap(Highcharts);

if (typeof window !== 'undefined') {
  window.proj4 = window.proj4 || proj4;
}

const select = state => {
  return {
    userId: state.auth.userId,
    token: state.auth.token
  };
};

function ConnectedAdminDashboard(props) {

  const { userId, token } = props;
  const [loading, setLoading] = useState(true);

  const [numActiveUsers, setNumActiveUsers] = useState(0);
  const [numBenefits, setNumBenefits] = useState(0);
  const [numBenefitApplications, setNumBenefitApplications] = useState(0);
  const [numResolvedBenefits, setNumResolvedBenefits] = useState(0);
  const [numProducts, setNumProducts] = useState(0);
  const [totalSales, setTotalSales] = useState(0);
  const [salesPerMonth, setSalesPerMonth] = useState([]);
  const [benefitsAmountPerMonth, setBenefitsAmountPerMonth] = useState([]);
  const [benefitCategories, setBenefitCategories] = useState([]);
  const [benefitApplicationCategories, setBenefitApplicationCategories] = useState([]);
  const [benefitsLocation, setBenefitsLocation] = useState([]);
  const [requestedBenefitsLocation, setRequestedBenefitsLocation] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setLoading(true);

    const dataProm = await fetch(`${apiUrl}/admin/get/dashboard`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userId,
        token,
        businessName
      })
    });

    const dataResp = await dataProm.json();

    if (dataResp.success) {
      setNumActiveUsers(dataResp.numActiveUsers);
      setNumBenefits(dataResp.numBenefits);
      setNumBenefitApplications(dataResp.numBenefitApplications);
      setNumResolvedBenefits(dataResp.numResolvedBenefits);
      setNumProducts(dataResp.numProducts);
      setTotalSales(dataResp.totalSales);
      setSalesPerMonth(dataResp.salesPerMonth);
      setBenefitsAmountPerMonth(dataResp.benefitsAmountPerMonth);
      setBenefitCategories(dataResp.benefitCategories);
      setBenefitApplicationCategories(dataResp.benefitApplicationCategories);
      setBenefitsLocation(dataResp.benefitsLocation);
      setRequestedBenefitsLocation(dataResp.requestedBenefitsLocation);
    }

    setLoading(false);
  };

  const mapOptions = {
    chart: {
      map: 'countries/co/co-all'
    },
    title: {
      text: ' '
    },
    credits: {
      enabled: false
    },
    mapNavigation: {
      enabled: false
    },
    tooltip: {
      headerFormat: '',
      pointFormat: '{point.keyword}: {point.z}'
    },
    series: [
      {
        // Use the gb-all map with no data as a basemap.
        name: 'Basemap',
        mapData: mapDataIE,
        borderColor: '#A0A0A0',
        nullColor: 'rgba(200, 200, 200, 0.3)',
        showInLegend: false
      },
      {
        // Specify points using lat/lon.
        type: 'mapbubble',
        name: 'Ubicación',
        color: '#4169E1',
        data: benefitsLocation,
        cursor: 'pointer'
      }
    ]
  };

  const mapOptions2 = {
    chart: {
      map: 'countries/co/co-all'
    },
    title: {
      text: ' '
    },
    credits: {
      enabled: false
    },
    mapNavigation: {
      enabled: false
    },
    tooltip: {
      headerFormat: '',
      pointFormat: '{point.keyword}: {point.z}'
    },
    series: [
      {
        // Use the gb-all map with no data as a basemap.
        name: 'Basemap',
        mapData: mapDataIE,
        borderColor: '#A0A0A0',
        nullColor: 'rgba(200, 200, 200, 0.3)',
        showInLegend: false
      },
      {
        // Specify points using lat/lon.
        type: 'mapbubble',
        name: 'Ubicación',
        color: '#4169E1',
        data: requestedBenefitsLocation,
        cursor: 'pointer'
      }
    ]
  };

  if (loading) {
    return (
      <div className="admin-dashboard-component">
        <div className="center">
          <Spinner variant="primary" animation="grow" />
        </div>
      </div>
    );
  }

  return (
    <div className="admin-dashboard-component">
      <Container>
        <Row>
          <Col xs={12}>
            <Alert variant="info">
              <h5># Usuarios activos: {numActiveUsers}</h5>
              <h5># Necesidades creadas: {numBenefitApplications}</h5>
              <h5># Ayudas ofrecidas: {numBenefits}</h5>
              <h5># Ayudas recibidas: {numResolvedBenefits}</h5>
              <h5># Productos creados: {numProducts}</h5>
              <h5>Ventas totales: ${formatMoney(totalSales)}</h5>
            </Alert>

            <h4>Ventas x Mes</h4>
            <ResponsiveContainer width="100%" height={250}>
              <LineChart data={salesPerMonth} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="tag" />
                <YAxis tickFormatter={value => formatMoney(value)} />
                <Tooltip formatter={value => `$${formatMoney(value)}`} />
                <Line name="Total" type="monotone" dataKey="amount" stroke="#072450" />
              </LineChart>
            </ResponsiveContainer>
            <br /><br />

            <h4>Donaciones x Mes</h4>
            <ResponsiveContainer width="100%" height={250}>
              <LineChart data={benefitsAmountPerMonth} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="tag" />
                <YAxis tickFormatter={value => formatMoney(value)} />
                <Tooltip formatter={value => `$${formatMoney(value)}`} />
                <Line name="Total" type="monotone" dataKey="amount" stroke="#072450" />
              </LineChart>
            </ResponsiveContainer>
            <br /><br />
          </Col>
          <Col md={6}>
            <h4>Ayudas más ofrecidas</h4>
            <ResponsiveContainer width="100%" height={250}>
              <PieChart>
                <Pie
                  data={benefitCategories}
                  dataKey="total"
                  nameKey="_id"
                  cx="50%"
                  cy="50%"
                  fill="#072450"
                  labelLine={false}
                  label={value => `${value._id.charAt(0).toUpperCase()}${value._id.slice(1).toLowerCase()}: ${value.total}`}
                />
              </PieChart>
            </ResponsiveContainer>
          </Col>
          <Col md={6}>
            <h4>Ayudas más solicitadas</h4>
            <ResponsiveContainer width="100%" height={250}>
              <PieChart>
                <Pie
                  data={benefitApplicationCategories}
                  dataKey="total"
                  nameKey="_id"
                  cx="50%"
                  cy="50%"
                  fill="#072450"
                  labelLine={false}
                  label={value => `${value._id.charAt(0).toUpperCase()}${value._id.slice(1).toLowerCase()}: ${value.total}`}
                />
              </PieChart>
            </ResponsiveContainer>
          </Col>
          <Col xs={6}>
            <h4>Ayudas ofrecidas por ubicación</h4>
            <HighchartsReact
              constructorType={"mapChart"}
              highcharts={Highcharts}
              options={mapOptions}
            />
          </Col>
          <Col xs={6}>
            <h4>Ayudas solicitadas por ubicación</h4>
            <HighchartsReact
              constructorType={"mapChart"}
              highcharts={Highcharts}
              options={mapOptions2}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

const AdminDashboard = connect(select)(ConnectedAdminDashboard);

export default AdminDashboard;
